import React from "react";
import { Dialog, DialogContent } from "../ui/dialog";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DIPLOMAS = [
    "27.png",
    "28.jpeg",
    "29.jpg",
    "30.png",
    "31.jpg",
    "32.png",
    "33.png",
    "34.png",
    "35.png",
    "36.jpg",
];

export const DiplomasSection = () => {
    const [selected, setSelected] = React.useState(null);

    return (
        <section className="py-16 bg-white relative overflow-hidden">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <h2 className="font-serif text-3xl text-olive-950 mb-8">
                    Мои дипломы
                </h2>

                <Carousel
                    className="w-full"
                    opts={{ align: "start", slidesToScroll: 1 }}
                >
                    <CarouselContent>
                        {DIPLOMAS.map((file, index) => (
                            <CarouselItem
                                key={file}
                                className="basis-1/2 md:basis-1/3 lg:basis-1/4"
                            >
                                <button
                                    onClick={() => setSelected(file)}
                                    className="w-full h-48 rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer focus:outline-none focus:ring-2 focus:ring-olive-400 flex items-center justify-center bg-white"
                                >
                                    <img
                                        src={`/diplomas/${file}`}
                                        alt={`Диплом ${index + 1}`}
                                        className="w-full h-full object-contain"
                                        loading="lazy"
                                    />
                                </button>
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <div className="flex items-center justify-center gap-4 mt-6">
                        <CarouselPrevious className="static translate-y-0" />
                        <CarouselNext className="static translate-y-0" />
                    </div>
                </Carousel>
            </div>

            <Dialog open={!!selected} onOpenChange={(open) => !open && setSelected(null)}>
                <DialogContent className="max-w-[90vw] sm:max-w-3xl p-2 bg-white/95 backdrop-blur-sm">
                    <div className="relative w-full flex items-center justify-center max-h-[85vh]">
                        {selected && (
                            <img
                                src={`/diplomas/${selected}`}
                                alt="Диплом"
                                className="max-w-full max-h-[85vh] object-contain rounded-md"
                            />
                        )}
                    </div>
                    <div className="absolute inset-y-0 left-0 flex items-center">
                        <button
                            onClick={() => {
                                const idx = DIPLOMAS.indexOf(selected);
                                if (idx > 0) setSelected(DIPLOMAS[idx - 1]);
                            }}
                            disabled={!selected || DIPLOMAS.indexOf(selected) === 0}
                            className="ml-2 p-2 rounded-full bg-white/80 hover:bg-white shadow-md disabled:opacity-30 transition-opacity"
                        >
                            <ChevronLeft className="w-6 h-6 text-olive-900" />
                        </button>
                    </div>
                    <div className="absolute inset-y-0 right-0 flex items-center">
                        <button
                            onClick={() => {
                                const idx = DIPLOMAS.indexOf(selected);
                                if (idx < DIPLOMAS.length - 1) setSelected(DIPLOMAS[idx + 1]);
                            }}
                            disabled={!selected || DIPLOMAS.indexOf(selected) === DIPLOMAS.length - 1}
                            className="mr-2 p-2 rounded-full bg-white/80 hover:bg-white shadow-md disabled:opacity-30 transition-opacity"
                        >
                            <ChevronRight className="w-6 h-6 text-olive-900" />
                        </button>
                    </div>
                </DialogContent>
            </Dialog>
        </section>
    );
};
